export default "/images/eac93454c02c11cb4b430de90cc8b61b.avif";